export enum maudPageViewEvents {
  viewPatientsPage = 'View Patients Page',
  viewProviderTaskListPage = 'View Provider Task List Page',
  viewProviderCalendarPage = 'View Provider Calendar Page',
  viewInquiriesPage = 'View Inquiries Page',
  viewProfileCalendarPage = 'Maud View Provider Profile Calendar Page',
  viewProfileInfoPage = 'Maud View Provider Profile Info Page',
}

export enum adminPageViewEvents {
  viewProfileInfoPage = 'Admin View Provider Profile Info Page ',
  viewProfileCalendarPage = 'Admin View Provider Profile Calendar Page',
}

export const maudPageTitles: Record<string, string> = {
  calendar: maudPageViewEvents.viewProviderCalendarPage,
  inquiries: maudPageViewEvents.viewInquiriesPage,
  patients: maudPageViewEvents.viewPatientsPage,
  tasks: maudPageViewEvents.viewProviderTaskListPage,
};

export const adminPageTitles: Record<string, string> = {
  calendar: adminPageViewEvents.viewProfileCalendarPage,
  info: adminPageViewEvents.viewProfileInfoPage,
};

export const profilePageTitles: Record<string, string> = {
  calendar: maudPageViewEvents.viewProfileCalendarPage,
  info: maudPageViewEvents.viewProfileInfoPage,
};

export const getMaudPageTitle = (page: string): string | undefined => {
  const regex = /^\/maud\/([^/]+)/;
  const match = page?.match(regex);
  if (match) {
    const token = match[1];
    return maudPageTitles[token];
  }
  return undefined;
};

export const getAdminPageTitle = (page: string): string | undefined => {
  const regex = /\/([^/]+)$/;
  const match = page?.match(regex);
  if (match) {
    const token = match[1];
    return adminPageTitles[token];
  }
  return undefined;
};

export const getProfilePageTitle = (page: string): string | undefined => {
  const regex = /^\/maud\/profile\/[^/]+\/([^/]+)$/;
  const match = page?.match(regex);
  if (match && match[1]) {
    return profilePageTitles[match[1]];
  }

  return undefined;
};
